// eslint-disable-next-line confluence-feature-gating/unsafe-no-exposure
import { UNSAFE_noExposureExp } from '@confluence/feature-experiments';

/**
 * Reads the experimentStartDate param from the cfind_5565_creation_focused_nav_xflow
 * experiment config without firing an exposure. Falls back to 2026-05-07 (the gate
 * rollout date) if the param is missing. Returns null only if the value is not a valid date.
 */
// eslint-disable-next-line confluence-feature-gating/unsafe-no-exposure
const XFLOW_EXPERIMENT_START_DATE_FALLBACK = '2026-05-07';

export const getXflowExperimentStartDate = (): Date | null => {
	// eslint-disable-next-line confluence-feature-gating/unsafe-no-exposure
	const [expConfig] = UNSAFE_noExposureExp('cfind_5565_creation_focused_nav_xflow'); // Experiment exposure is fired elsewhere
	const rawValue = expConfig.get('experimentStartDate', XFLOW_EXPERIMENT_START_DATE_FALLBACK);
	const date = new Date(rawValue);
	return isNaN(date.getTime()) ? null : date;
};
